import React from 'react'
import UserListComponent from '../Components/User/UserListComponent'

function UserPage() {
    return (
        <UserListComponent/>
    )
}

export default UserPage